import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es.array.concat.js";
import fetch from '../../shared/utils/fetch';
export default /*#__PURE__*/(function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var baseUrl,
      bundlePath,
      bundlePart,
      filter,
      bundle,
      bundleChunk,
      _args = arguments;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          baseUrl = _ref.baseUrl, bundlePath = _ref.bundlePath, bundlePart = _ref.bundlePart;
          filter = _args.length > 1 && _args[1] !== undefined ? _args[1] : function (x) {
            return x;
          };
          _context.next = 4;
          return fetch("".concat(baseUrl).concat(bundlePath));
        case 4:
          bundle = _context.sent;
          bundleChunk = bundle[bundlePart];
          if (bundleChunk) {
            _context.next = 8;
            break;
          }
          return _context.abrupt("return", null);
        case 8:
          return _context.abrupt("return", filter(bundleChunk));
        case 9:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function (_x) {
    return _ref2.apply(this, arguments);
  };
})();